import React, {useState, useRef, useEffect, useContext} from "react";
import {useMsal} from "@azure/msal-react";
import {userInfoContext} from "../../App";

import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import AssignmentIndOutlinedIcon from "@mui/icons-material/AssignmentIndOutlined";
import SupportAgentOutlinedIcon from "@mui/icons-material/SupportAgentOutlined";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";

import {Link} from "react-router-dom";

import "../../style/sideBarMenu.css";

export default function SidebarMenu() {
    const {instance} = useMsal();
    const [userInfo] = useContext(userInfoContext);

    const handleLogout = (loginType) => {
        if (loginType === "redirect") {
            instance.logoutRedirect().catch((e) => {
                console.log("error", e);
            });
        }
    };

    const [isOpen, setIsOpen] = useState(false);
    const sidebarRef = useRef<HTMLDivElement>(null);

    // Close sidebar when clicking outside
    useEffect(() => {
        function handleClickOutside(event: MouseEvent) {
            if (sidebarRef.current && !sidebarRef.current.contains(event.target as Node)) {
                setIsOpen(false);
            }
        }

        if (isOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isOpen]);

    return (
        <>
            {/* Button to open menu */}
            <div className="menu-button" onClick={() => setIsOpen(true)}>
                <span>Meny</span>
                <div className="menu-icon">
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
            </div>

            {/* Overlay */}
            {isOpen && <div className="fixed inset-0 bg-black/30 z-40"></div>}

            {/* Sidebar */}
            <div
                ref={sidebarRef}
                className={`fixed top-0 right-0 h-full w-96 bg-white shadow-lg z-50 transform transition-transform duration-300 ${
                    isOpen ? "translate-x-0" : "translate-x-full"
                }`}
            >
                {/* Header */}
                <div className="flex justify-end items-center px-4 py-4 border-b">
                    <button onClick={() => setIsOpen(false)} className="flex items-center gap-2">
                        <span className="text-sm font-medium">Lukk &nbsp;&nbsp;X</span>
                    </button>
                </div>

                {/* Menu items */}
                <div className="menu-container">
                    <div className="menu-profile-card">
                        {userInfo.ImageUrl ? (
                            <img className="profile-image-menu" src={userInfo.ImageUrl} alt="Profile"></img>
                        ) : (
                            <AccountCircleIcon sx={{fontSize: 48}}/>
                        )}

                        <div style={{marginLeft: "1.3rem"}}>
                            <div style={{fontWeight: "700"}}>{userInfo.Name}</div>
                            <div className="edit-profile-link-div">
                                <Link className="edit-profile-link" to="/editprofile" onClick={() => setIsOpen(false)}>
                                    Rediger
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="menu-link-divs">
                        <Link className="menu-link" onClick={() => setIsOpen(false)} to="/">
                            <div className="menu-link-div">
                                <HomeRoundedIcon/>
                                <span className="menu-link-title">Hjem</span>
                            </div>
                        </Link>

                        {/*<Link className="menu-link" onClick={() => setIsOpen(false)} to="/responsibility">*/}
                        {/*    <div className="menu-link-div">*/}
                        {/*        <AssignmentRoundedIcon/>*/}
                        {/*        <span className="menu-link-title">Ansvarsområde</span>*/}
                        {/*    </div>*/}
                        {/*</Link>*/}

                        {/*<Link className="menu-link" onClick={() => setIsOpen(false)} to="/statistics">*/}
                        {/*    <div className="menu-link-div">*/}
                        {/*        <QueryStatsOutlinedIcon/>*/}
                        {/*        <span className="menu-link-title">Statistikk</span>*/}
                        {/*    </div>*/}
                        {/*</Link>*/}
                        <Link className="menu-link" onClick={() => setIsOpen(false)} to="https://support.karnov.no/">
                            <div className="menu-link-div">
                                <SupportAgentOutlinedIcon/>
                                <span className="menu-link-title">Support</span>
                            </div>
                        </Link>
                        <Link className="menu-link" onClick={() => setIsOpen(false)} to="/profile">
                            <div className="menu-link-div">
                                <AssignmentIndOutlinedIcon/>
                                <span className="menu-link-title">Min profil</span>
                            </div>
                        </Link>
                    </div>
                </div>

                {/* Footer */}
                <div className="absolute bottom-4 left-0 w-full px-6">
                    <button className="logout-button" onClick={() => handleLogout("redirect")}>
            <span className="logout-icon">
              <LogoutOutlinedIcon/>
            </span>
                        <span className="logout-text">Logg ut</span>
                    </button>
                </div>
            </div>
        </>
    );
}
